<div class="row">
  <div class="col-12">
    <career-header></career-header>
  </div>
  <div class="col-12">
    <career-content></career-content>
  </div>
  <div class="col-12">
    <app-app-footer></app-app-footer>
  </div>
</div>
